export default __webpack_public_path__ + "static/media/coinca II sala.fe2ec6e6.jpg";